import { render, staticRenderFns } from "./testimonial.vue?vue&type=template&id=4de6ed9b&"
import script from "./testimonial.vue?vue&type=script&lang=ts&"
export * from "./testimonial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports